import { render, staticRenderFns } from "./noticeAction.vue?vue&type=template&id=2868e3d7&scoped=true"
import script from "./noticeAction.vue?vue&type=script&lang=js"
export * from "./noticeAction.vue?vue&type=script&lang=js"
import style0 from "./noticeAction.vue?vue&type=style&index=0&id=2868e3d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2868e3d7",
  null
  
)

export default component.exports